import './ModalOptions.css';

import * as cardService from "../services/cardServices";
import * as http from "../services/httpServices";
import * as userService from "../services/userServices";
import * as utils from "../services/utilsServices";

import React, { Component } from 'react';

import CustomModal from './CustomModal'
import { toast } from "react-toastify";

export class NewUser extends Component {
    static displayName = NewUser.name;
    state = {
        showModal: false,

        deviceName: "",
        deviceNumber: "",
        list: [],
    };


    componentDidMount() {
        this.getUser();
    }

    clearData = () => {
        this.setState({ deviceName: "", deviceNumber: "" });
    }
    getUser = () => {
        let card = userService.getUser();
        this.setState({ list: card });
        //console.log('dd',card); 
    }

    doAddDevice = (e) => {
        e.preventDefault();
        if (this.state.deviceName==null || this.state.deviceName.length<=0){
            toast.error('نام را وارد فرمایید');
            return;
        }
        let temp = utils.checkNumber(this.state.deviceNumber);        
        userService.addSaveUser([{
            deviceName: this.state.deviceName,
            deviceNumber: temp,
            id: (new Date()).getTime(),
        }]);
        let choice = cardService.getChoiceCard();
        utils.sendSms(choice.deviceNumber, `add,${temp}`);
        toast.dark('لطفا تا دریافت پیامک از دستگاه صبر کنید ...');
        this.getUser();
        this.clearData();
        //this.props.closeModal(e);
    }

    componentDidUpdate(prevProps, prevState) {
        console.log('prevProps1', prevProps);
        console.log('prevState1', prevState);
        if (prevProps.showModal != this.state.showModal) {
            this.setState({ showModal: prevProps.showModal })
            this.getUser();
            this.clearData();
            console.log('prevState1-----');
        }
    }

    handleChangeUser = (event, item, index) => {
        const target = event.target;
        const value = target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value;
        //const value = target.value;
        const name = target.name;
        let list = this.state.list;
        for (let i = 0; i < list.length; i++)
            list[i].ch = false;
        //console.log('ff1',list);
        list[index][name] = value;
        //console.log('ff2',list);
        this.setState({ list: list });

    }
    doDelete= (e,item,index)=>{
        e.preventDefault();
        let list = this.state.list;
        //console.log('list[index]',list[index]);               
        let choice = cardService.getChoiceCard();
        utils.sendSms(choice.deviceNumber, `del,${list[index].deviceNumber}`);
        toast.dark('لطفا تا دریافت پیامک از دستگاه صبر کنید ...');
        userService.deleteUser(list[index].id);        
        this.getUser();

    }
    /*
    deleteItem = (e) => {
        e.preventDefault();
        let list = this.state.list;
        for (let i = 0; i < list.length; i++)
            if (list[i].ch == true) {
                //console.log('ff',list[i]);
                userService.deleteUser(list[i].id);
            }
        this.getUser()
    }*/

    render() {
        let listDevice = this.state.list.map((item, index) => {
            return (
                <div className="row" key={"device" + index}>
                    <div className="col-auto">
                    <img src="images/contact_del.png" onClick={(e)=>this.doDelete(e,item,index)} />
                        {/*<input type="radio"
                            name="ch"
                            checked={item.ch == true}
            onChange={(e) => this.handleChangeUser(e, item, index)} />*/}
                    </div>
                    <div className="col">
                        <span>{item.deviceName}</span>
                    </div>
                    <div className="col">
                        <span>{item.deviceNumber}</span>
                    </div>
                </div>
            )
        });
        return (
            <>
                <CustomModal show={this.props.showModal} onClose={(e) => { this.props.closeModal(e) }} >
                    <div className="" id="containAddDevice">
                        <div className="row">
                            <div className="col">
                                <div className="d-flex justify-content-center">افزودن کاربر</div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <input type="text"
                                    className="form-control inputControlModal" placeholder="نام نام خانوادگی کاربر"
                                    name="deviceName"
                                    value={this.state.deviceName}
                                    onChange={(e) => http.handleChange(e, this)}
                                />
                            </div>
                            <div className="col">
                                <input type="number"
                                    name="deviceNumber"
                                    value={this.state.deviceNumber}
                                    onChange={(e) => http.handleChange(e, this)}
                                    className="form-control inputControlModal" placeholder="شماره همراه" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                {/*<div id="addPicture">افزودن عکس</div>*/}
                            </div>
                            <div className="col">
                                <a onClick={(e) => this.doAddDevice(e)}>
                                    <img src="images/accept.svg" className="imgButtonModal"></img>
                                </a>
                                <a onClick={(e) => this.props.closeModal(e)}>
                                    <img src="images/cancel.svg" className="imgButtonModal"></img>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="row" id="containNumberDevice">
                            <div className="col">
                                {listDevice}
                            </div>
                            <div className="row">
                                <div className="col text-center">
                                 {/*   <img src="images/deleteUser.svg" onClick={(e) => this.deleteItem(e)} />*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </CustomModal>
            </>

        );
    }


}